import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

export const GameFilter = ({ selected, setSelected }) => {
    const { allDirectusGame: gameQuery } = useStaticQuery(
        graphql`
            query GameQuery {
                allDirectusGame(sort: { fields: [name], order: ASC }) {
                    nodes {
                        directusId
                        name
                        ref
                    }
                }
            }
        `
    );
    const selectedGame =
        selected && gameQuery.nodes.find((game) => game.ref === selected);
    const handleSelect = (event, values) => {
        // It's not a proper Select element so we're not using event.target.value
        if (values === null) {
            setSelected(undefined);
        } else {
            setSelected(values.ref);
        }
    };

    return (
        <Autocomplete
            getOptionLabel={(option) => option.name}
            id="game-filter"
            onChange={handleSelect}
            options={gameQuery.nodes}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    label="All Games"
                    margin="dense"
                    variant="outlined"
                />
            )}
            value={selectedGame || null}
        />
    );
};
